import axios from 'axios';
import { saveAs } from 'file-saver';

export async function downloadCsv({ baseUrl, token, path, params = {}, filename }) {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === null || v === undefined || v === '') continue;
    if (Array.isArray(v)) {
      for (const item of v) {
        if (item === null || item === undefined || item === '') continue;
        qs.append(k, String(item));
      }
    } else {
      qs.append(k, String(v));
    }
  }
  const qsStr = qs.toString();

  const url = `${baseUrl}${path}${qsStr ? `?${qsStr}` : ''}`;

  const { data } = await axios.get(url, {
    responseType: 'blob',
    headers: { Authorization: `Bearer ${String(token ?? '').trim()}` },
  });

  saveAs(new Blob([data], { type: 'text/csv;charset=utf-8' }), filename);
}
